<template>
  <section class="content">
    <admin-header
      :title="'Roles'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminRole',
    data () {
      return {
        newEntityScreen: 'Admin - Roles',
        searchEntityScreen: 'Admin - Role search',
        filterEventName: 'admin-role-filter',
        filterName: 'RoleFilter',
        entityName: 'role'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminRole.vue?0528c03e